import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ToastContainer, notify } from '../../libraries/notifications';
import { Link } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import { getOwner, capitalize } from '../../libraries/utils';

import config from '../../config';

import PurchaseCard from '../../components/customs/PurchaseCard';
import LayoutWithSidebar from '../../components/layout/LayoutWithSidebar';
import Icon from '../../libraries/icons';
import SearchInput from '../../components/forms/SearchInput';
import Loader from '../../components/commons/Loader';

import purchasesActions from '../../context/purchases/actions';

class MyPurchases extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      purchases: [],
      search: ""
    }
  }
  
  componentDidMount() {
    this.getPurchases();
  }

  getPurchases = async () => {
    const {search,} = this.state
    const params = { target: getOwner(this.props.auth.user), type: config.TRANSACTIONS.PURCHASE.TYPE }

    if (search && search !== ""){
      //params.where = {"json_data":[{"field":"pharmacy", "value":filters.specialty}]};
    }



    await this.props.onGetAll(params);
    const { purchases } = this.props;
    if (purchases.error) { 
      notify(this.t(purchases.error.message));
    } else {
      this.setState({ purchases: purchases.items });
    }
  }

  searchClear = (form) => {
    form.change('search', undefined);
    this.searchOnClick({search: ''});
  }

  searchOnClick = async (values) => {
    console.log("Search on Click", values.search);
    if (this.state.search !== values.search) this.setState({ search: values.search || '' }, () => this.getPurchases() );
  };


  render() {

    const {purchases} = this.state;

    return (
      <LayoutWithSidebar
        main={{ className: "bg-base-200"}}
        header={{ 
          title: this.t("Mis compras"),
        }}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="h-10 bg-primary"></section>
        <section className="section-card">
          <Form initialValues={{}} onSubmit={this.searchOnClick}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto mb-4">
                <Field name="search" component={SearchInput} placeholder={this.t("Search")} onClick={this.searchOnClick} onClearClick={() => this.searchClear(form) }/>
              </form>
            )}
          </Form>
          <div>
            { this.props.purchases.loading && (<Loader containerClassName="mt-10"/>) }
            { !this.props.purchases.loading && purchases.length === 0 && (
              <div className="text-center p-10">
                <Icon className="h-24 w-24 mx-auto mb-3" name="shopping_bag" />
                <h4 className="mb-1">{this.t("No hay compras")}</h4>
              </div>
            ) }
            { purchases.map((purchase, index) => {
              return (
                <PurchaseCard
                  key={index}
                  purchase={purchase}
                  status={purchase.status}
                  route={config.ROUTES.PURCHASES.DETAIL.replace(':id', purchase.id)}
                />
              )}
            )}
          </div>
        </section>
      </LayoutWithSidebar>      
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,    
    purchases: state.purchases.list,
    purchase: state.purchases.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAll: (params) => dispatch(purchasesActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(MyPurchases));
